import { FIRMWARE_VERSION } from './constants';

const convertToComparableNumber = (version) => {
  if (typeof version !== 'string' || !version) {
    return null;
  }

  const match = version.match(/[Vv]([\d.]+)/);
  if (!match) {
    return null;
  }

  const numericPart = match[1].replace(/\./g, '');
  return parseInt(numericPart, 10);
}

export const shouldToggleVAD = (dbVersion) => {
  const firmwareVersion = FIRMWARE_VERSION;

  const comparableDBVersion = convertToComparableNumber(dbVersion);
  const comparableFirmwareVersion = convertToComparableNumber(firmwareVersion);

  if (!comparableDBVersion || !comparableFirmwareVersion) {
    return false;
  }

  return comparableDBVersion >= comparableFirmwareVersion;
}
